"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const constants_1 = require("../../../../common/constants");
const store_1 = require("../../../../context/store");
const enums_1 = require("../../../../common/enums");
const common_1 = require("../../../../utils/common");
const react_1 = require("react");
const getOffsetTop = (hour, format, hourHeight, isAfter12) => {
    if (format === enums_1.TIME_FORMAT.H_24) {
        return parseInt(hour) * hourHeight - 4;
    }
    if (format === enums_1.TIME_FORMAT.H_12 && !isAfter12) {
        return parseInt(hour) * hourHeight - 4;
    }
    else {
        return (parseInt(hour) + 12) * hourHeight - 4;
    }
};
const renderHours = (width, hourHeight, isDark, timeFormat) => {
    let isAfter12 = false;
    return (0, common_1.createVerticalHours)(timeFormat).map((hour) => {
        if (hour === '1 PM') {
            isAfter12 = true;
        }
        return hour === '00' ||
            hour === '24' ||
            hour === '0 AM' ||
            hour === '24 PM' ? ((0, jsx_runtime_1.jsx)("div", { className: 'Kalend__CalendarBodyHours__container', style: { minHeight: hourHeight } }, hour)) : ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: 'Kalend__CalendarBodyHours__container', style: { minHeight: hourHeight } }, { children: [(0, jsx_runtime_1.jsx)("p", Object.assign({ className: (0, common_1.parseCssDark)('Kalend__text Kalend__CalendarBodyHours__text', isDark), style: {
                        top: getOffsetTop(hour, timeFormat, hourHeight, isAfter12),
                        left: 10,
                    } }, { children: hour })), (0, jsx_runtime_1.jsx)("div", { className: (0, common_1.parseCssDark)('Kalend__text Kalend__CalendarBodyHours__line', isDark), style: { width: width - constants_1.CALENDAR_OFFSET_LEFT } })] }), hour));
    });
};
const CalendarBodyHours = () => {
    const [store] = (0, react_1.useContext)(store_1.Context);
    const { width, config, isDark, height } = store;
    const { hourHeight, timeFormat } = config;
    const hours = renderHours(width, hourHeight, isDark, timeFormat);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'Kalend__CalendarBodyHours__wrapper', style: { height } }, { children: hours })));
};
exports.default = CalendarBodyHours;
